// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/push_rules/v1/push_rules.proto" (package "c1.api.push_rules.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserTargeting
 */
export interface UserTargeting {
    /**
     * @generated from protobuf oneof: target
     */
    target: {
        oneofKind: "all";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.AllUsers all = 1
         */
        all: AllUsers;
    } | {
        oneofKind: "cel";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.CelExpression cel = 2
         */
        cel: CelExpression;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.AllUsers
 */
export interface AllUsers {
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.CelExpression
 */
export interface CelExpression {
    /**
     * @generated from protobuf field: string expression = 1
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfiguration
 */
export interface UserAttributePushConfiguration {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: bool enabled = 3
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserTargeting user_targeting = 4
     */
    userTargeting?: UserTargeting;
    /**
     * @generated from protobuf field: bool allows_custom_attribute_names = 5
     */
    allowsCustomAttributeNames: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_push_at = 8
     */
    lastPushAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationRef
 */
export interface UserAttributePushConfigurationRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRule
 */
export interface UserAttributePushRule {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string target_attribute_name = 3
     */
    targetAttributeName: string;
    /**
     * @generated from protobuf oneof: mapping_rule
     */
    mappingRule: {
        oneofKind: "none";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.None none = 100
         */
        none: None;
    } | {
        oneofKind: "c1Attribute";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.C1Attribute c1_attribute = 101
         */
        c1Attribute: C1Attribute;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.CelExpression cel_expression = 102
         */
        celExpression: CelExpression;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool is_custom = 4
     */
    isCustom: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.None
 */
export interface None {
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.C1Attribute
 */
export interface C1Attribute {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1
     */
    userAttributeMappingId: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetRequest
 */
export interface UserAttributePushConfigurationServiceGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetResponse
 */
export interface UserAttributePushConfigurationServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserAttributePushConfiguration configuration = 1
     */
    configuration?: UserAttributePushConfiguration;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateRequest
 */
export interface UserAttributePushConfigurationServiceUpdateRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: bool enabled = 3
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserTargeting user_targeting = 4
     */
    userTargeting?: UserTargeting;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 5
     */
    updateMask?: FieldMask;
    /**
     * Optional: if provided, rules will be updated atomically with the configuration
     *
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRuleInput rules = 6
     */
    rules: UserAttributePushRuleInput[];
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateResponse
 */
export interface UserAttributePushConfigurationServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserAttributePushConfiguration configuration = 1
     */
    configuration?: UserAttributePushConfiguration;
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRule rules = 2
     */
    rules: UserAttributePushRule[];
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceListRequest
 */
export interface UserAttributePushConfigurationServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceListResponse
 */
export interface UserAttributePushConfigurationServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushConfiguration list = 1
     */
    list: UserAttributePushConfiguration[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateRequest
 */
export interface UserAttributePushRuleServiceUpdateRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRule rules = 3
     */
    rules: UserAttributePushRule[];
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateResponse
 */
export interface UserAttributePushRuleServiceUpdateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRule rules = 1
     */
    rules: UserAttributePushRule[];
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceListRequest
 */
export interface UserAttributePushRuleServiceListRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceListResponse
 */
export interface UserAttributePushRuleServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRule list = 1
     */
    list: UserAttributePushRule[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateRequest
 */
export interface UserAttributePushConfigurationServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: bool enabled = 3
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserTargeting user_targeting = 4
     */
    userTargeting?: UserTargeting;
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRuleInput rules = 5
     */
    rules: UserAttributePushRuleInput[];
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateResponse
 */
export interface UserAttributePushConfigurationServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserAttributePushConfiguration configuration = 1
     */
    configuration?: UserAttributePushConfiguration;
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRule rules = 2
     */
    rules: UserAttributePushRule[];
}
/**
 * Input for creating a push rule - is_custom is derived by comparing target_attribute_name against the schema
 *
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRuleInput
 */
export interface UserAttributePushRuleInput {
    /**
     * @generated from protobuf field: string target_attribute_name = 1
     */
    targetAttributeName: string;
    /**
     * @generated from protobuf oneof: mapping_rule
     */
    mappingRule: {
        oneofKind: "none";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.None none = 100
         */
        none: None;
    } | {
        oneofKind: "c1Attribute";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.C1Attribute c1_attribute = 101
         */
        c1Attribute: C1Attribute;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.CelExpression cel_expression = 102
         */
        celExpression: CelExpression;
    } | {
        oneofKind: undefined;
    };
}
/**
 * A pushable attribute from the connector's action schema
 *
 * @generated from protobuf message c1.api.push_rules.v1.PushableAttribute
 */
export interface PushableAttribute {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.GetConnectorPushSchemaRequest
 */
export interface GetConnectorPushSchemaRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.GetConnectorPushSchemaResponse
 */
export interface GetConnectorPushSchemaResponse {
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.PushableAttribute attributes = 1
     */
    attributes: PushableAttribute[];
    /**
     * @generated from protobuf field: bool allows_custom_attributes = 2
     */
    allowsCustomAttributes: boolean;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteRequest
 */
export interface UserAttributePushConfigurationServiceDeleteRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteResponse
 */
export interface UserAttributePushConfigurationServiceDeleteResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class UserTargeting$Type extends MessageType<UserTargeting> {
    constructor() {
        super("c1.api.push_rules.v1.UserTargeting", [
            { no: 1, name: "all", kind: "message", oneof: "target", T: () => AllUsers },
            { no: 2, name: "cel", kind: "message", oneof: "target", T: () => CelExpression }
        ]);
    }
    create(value?: PartialMessage<UserTargeting>): UserTargeting {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.target = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UserTargeting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserTargeting): UserTargeting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.push_rules.v1.AllUsers all */ 1:
                    message.target = {
                        oneofKind: "all",
                        all: AllUsers.internalBinaryRead(reader, reader.uint32(), options, (message.target as any).all)
                    };
                    break;
                case /* c1.api.push_rules.v1.CelExpression cel */ 2:
                    message.target = {
                        oneofKind: "cel",
                        cel: CelExpression.internalBinaryRead(reader, reader.uint32(), options, (message.target as any).cel)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserTargeting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.push_rules.v1.AllUsers all = 1; */
        if (message.target.oneofKind === "all")
            AllUsers.internalBinaryWrite(message.target.all, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.push_rules.v1.CelExpression cel = 2; */
        if (message.target.oneofKind === "cel")
            CelExpression.internalBinaryWrite(message.target.cel, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserTargeting
 */
export const UserTargeting = new UserTargeting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllUsers$Type extends MessageType<AllUsers> {
    constructor() {
        super("c1.api.push_rules.v1.AllUsers", []);
    }
    create(value?: PartialMessage<AllUsers>): AllUsers {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AllUsers>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AllUsers): AllUsers {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AllUsers, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.AllUsers
 */
export const AllUsers = new AllUsers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CelExpression$Type extends MessageType<CelExpression> {
    constructor() {
        super("c1.api.push_rules.v1.CelExpression", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<CelExpression>): CelExpression {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expression = "";
        if (value !== undefined)
            reflectionMergePartial<CelExpression>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CelExpression): CelExpression {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expression */ 1:
                    message.expression = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CelExpression, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string expression = 1; */
        if (message.expression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expression);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.CelExpression
 */
export const CelExpression = new CelExpression$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfiguration$Type extends MessageType<UserAttributePushConfiguration> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfiguration", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "user_targeting", kind: "message", T: () => UserTargeting },
            { no: 5, name: "allows_custom_attribute_names", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "last_push_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfiguration>): UserAttributePushConfiguration {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.enabled = false;
        message.allowsCustomAttributeNames = false;
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfiguration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfiguration): UserAttributePushConfiguration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* bool enabled */ 3:
                    message.enabled = reader.bool();
                    break;
                case /* c1.api.push_rules.v1.UserTargeting user_targeting */ 4:
                    message.userTargeting = UserTargeting.internalBinaryRead(reader, reader.uint32(), options, message.userTargeting);
                    break;
                case /* bool allows_custom_attribute_names */ 5:
                    message.allowsCustomAttributeNames = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp last_push_at */ 8:
                    message.lastPushAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastPushAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfiguration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* bool enabled = 3; */
        if (message.enabled !== false)
            writer.tag(3, WireType.Varint).bool(message.enabled);
        /* c1.api.push_rules.v1.UserTargeting user_targeting = 4; */
        if (message.userTargeting)
            UserTargeting.internalBinaryWrite(message.userTargeting, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool allows_custom_attribute_names = 5; */
        if (message.allowsCustomAttributeNames !== false)
            writer.tag(5, WireType.Varint).bool(message.allowsCustomAttributeNames);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_push_at = 8; */
        if (message.lastPushAt)
            Timestamp.internalBinaryWrite(message.lastPushAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfiguration
 */
export const UserAttributePushConfiguration = new UserAttributePushConfiguration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationRef$Type extends MessageType<UserAttributePushConfigurationRef> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationRef>): UserAttributePushConfigurationRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationRef): UserAttributePushConfigurationRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationRef
 */
export const UserAttributePushConfigurationRef = new UserAttributePushConfigurationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRule$Type extends MessageType<UserAttributePushRule> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRule", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "target_attribute_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "255" } } } },
            { no: 100, name: "none", kind: "message", oneof: "mappingRule", T: () => None },
            { no: 101, name: "c1_attribute", kind: "message", oneof: "mappingRule", T: () => C1Attribute },
            { no: 102, name: "cel_expression", kind: "message", oneof: "mappingRule", T: () => CelExpression },
            { no: 4, name: "is_custom", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushRule>): UserAttributePushRule {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.targetAttributeName = "";
        message.mappingRule = { oneofKind: undefined };
        message.isCustom = false;
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushRule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushRule): UserAttributePushRule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string target_attribute_name */ 3:
                    message.targetAttributeName = reader.string();
                    break;
                case /* c1.api.push_rules.v1.None none */ 100:
                    message.mappingRule = {
                        oneofKind: "none",
                        none: None.internalBinaryRead(reader, reader.uint32(), options, (message.mappingRule as any).none)
                    };
                    break;
                case /* c1.api.push_rules.v1.C1Attribute c1_attribute */ 101:
                    message.mappingRule = {
                        oneofKind: "c1Attribute",
                        c1Attribute: C1Attribute.internalBinaryRead(reader, reader.uint32(), options, (message.mappingRule as any).c1Attribute)
                    };
                    break;
                case /* c1.api.push_rules.v1.CelExpression cel_expression */ 102:
                    message.mappingRule = {
                        oneofKind: "celExpression",
                        celExpression: CelExpression.internalBinaryRead(reader, reader.uint32(), options, (message.mappingRule as any).celExpression)
                    };
                    break;
                case /* bool is_custom */ 4:
                    message.isCustom = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushRule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string target_attribute_name = 3; */
        if (message.targetAttributeName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.targetAttributeName);
        /* bool is_custom = 4; */
        if (message.isCustom !== false)
            writer.tag(4, WireType.Varint).bool(message.isCustom);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.push_rules.v1.None none = 100; */
        if (message.mappingRule.oneofKind === "none")
            None.internalBinaryWrite(message.mappingRule.none, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.push_rules.v1.C1Attribute c1_attribute = 101; */
        if (message.mappingRule.oneofKind === "c1Attribute")
            C1Attribute.internalBinaryWrite(message.mappingRule.c1Attribute, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.push_rules.v1.CelExpression cel_expression = 102; */
        if (message.mappingRule.oneofKind === "celExpression")
            CelExpression.internalBinaryWrite(message.mappingRule.celExpression, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRule
 */
export const UserAttributePushRule = new UserAttributePushRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class None$Type extends MessageType<None> {
    constructor() {
        super("c1.api.push_rules.v1.None", []);
    }
    create(value?: PartialMessage<None>): None {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<None>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: None): None {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: None, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.None
 */
export const None = new None$Type();
// @generated message type with reflection information, may provide speed optimized methods
class C1Attribute$Type extends MessageType<C1Attribute> {
    constructor() {
        super("c1.api.push_rules.v1.C1Attribute", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<C1Attribute>): C1Attribute {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userAttributeMappingId = "";
        if (value !== undefined)
            reflectionMergePartial<C1Attribute>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: C1Attribute): C1Attribute {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_attribute_mapping_id */ 1:
                    message.userAttributeMappingId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: C1Attribute, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_attribute_mapping_id = 1; */
        if (message.userAttributeMappingId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userAttributeMappingId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.C1Attribute
 */
export const C1Attribute = new C1Attribute$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceGetRequest$Type extends MessageType<UserAttributePushConfigurationServiceGetRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationServiceGetRequest>): UserAttributePushConfigurationServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationServiceGetRequest): UserAttributePushConfigurationServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetRequest
 */
export const UserAttributePushConfigurationServiceGetRequest = new UserAttributePushConfigurationServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceGetResponse$Type extends MessageType<UserAttributePushConfigurationServiceGetResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetResponse", [
            { no: 1, name: "configuration", kind: "message", T: () => UserAttributePushConfiguration }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationServiceGetResponse>): UserAttributePushConfigurationServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationServiceGetResponse): UserAttributePushConfigurationServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.push_rules.v1.UserAttributePushConfiguration configuration */ 1:
                    message.configuration = UserAttributePushConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.configuration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.push_rules.v1.UserAttributePushConfiguration configuration = 1; */
        if (message.configuration)
            UserAttributePushConfiguration.internalBinaryWrite(message.configuration, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetResponse
 */
export const UserAttributePushConfigurationServiceGetResponse = new UserAttributePushConfigurationServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceUpdateRequest$Type extends MessageType<UserAttributePushConfigurationServiceUpdateRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "user_targeting", kind: "message", T: () => UserTargeting },
            { no: 5, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 6, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRuleInput }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationServiceUpdateRequest>): UserAttributePushConfigurationServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.enabled = false;
        message.rules = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationServiceUpdateRequest): UserAttributePushConfigurationServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* bool enabled */ 3:
                    message.enabled = reader.bool();
                    break;
                case /* c1.api.push_rules.v1.UserTargeting user_targeting */ 4:
                    message.userTargeting = UserTargeting.internalBinaryRead(reader, reader.uint32(), options, message.userTargeting);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 5:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* repeated c1.api.push_rules.v1.UserAttributePushRuleInput rules */ 6:
                    message.rules.push(UserAttributePushRuleInput.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* bool enabled = 3; */
        if (message.enabled !== false)
            writer.tag(3, WireType.Varint).bool(message.enabled);
        /* c1.api.push_rules.v1.UserTargeting user_targeting = 4; */
        if (message.userTargeting)
            UserTargeting.internalBinaryWrite(message.userTargeting, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 5; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.push_rules.v1.UserAttributePushRuleInput rules = 6; */
        for (let i = 0; i < message.rules.length; i++)
            UserAttributePushRuleInput.internalBinaryWrite(message.rules[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateRequest
 */
export const UserAttributePushConfigurationServiceUpdateRequest = new UserAttributePushConfigurationServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceUpdateResponse$Type extends MessageType<UserAttributePushConfigurationServiceUpdateResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateResponse", [
            { no: 1, name: "configuration", kind: "message", T: () => UserAttributePushConfiguration },
            { no: 2, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRule }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationServiceUpdateResponse>): UserAttributePushConfigurationServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rules = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationServiceUpdateResponse): UserAttributePushConfigurationServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.push_rules.v1.UserAttributePushConfiguration configuration */ 1:
                    message.configuration = UserAttributePushConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.configuration);
                    break;
                case /* repeated c1.api.push_rules.v1.UserAttributePushRule rules */ 2:
                    message.rules.push(UserAttributePushRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.push_rules.v1.UserAttributePushConfiguration configuration = 1; */
        if (message.configuration)
            UserAttributePushConfiguration.internalBinaryWrite(message.configuration, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.push_rules.v1.UserAttributePushRule rules = 2; */
        for (let i = 0; i < message.rules.length; i++)
            UserAttributePushRule.internalBinaryWrite(message.rules[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateResponse
 */
export const UserAttributePushConfigurationServiceUpdateResponse = new UserAttributePushConfigurationServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceListRequest$Type extends MessageType<UserAttributePushConfigurationServiceListRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationServiceListRequest>): UserAttributePushConfigurationServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationServiceListRequest): UserAttributePushConfigurationServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceListRequest
 */
export const UserAttributePushConfigurationServiceListRequest = new UserAttributePushConfigurationServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceListResponse$Type extends MessageType<UserAttributePushConfigurationServiceListResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushConfiguration },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationServiceListResponse>): UserAttributePushConfigurationServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationServiceListResponse): UserAttributePushConfigurationServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.push_rules.v1.UserAttributePushConfiguration list */ 1:
                    message.list.push(UserAttributePushConfiguration.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.push_rules.v1.UserAttributePushConfiguration list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserAttributePushConfiguration.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceListResponse
 */
export const UserAttributePushConfigurationServiceListResponse = new UserAttributePushConfigurationServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRuleServiceUpdateRequest$Type extends MessageType<UserAttributePushRuleServiceUpdateRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRule }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushRuleServiceUpdateRequest>): UserAttributePushRuleServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.rules = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushRuleServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushRuleServiceUpdateRequest): UserAttributePushRuleServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* repeated c1.api.push_rules.v1.UserAttributePushRule rules */ 3:
                    message.rules.push(UserAttributePushRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushRuleServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* repeated c1.api.push_rules.v1.UserAttributePushRule rules = 3; */
        for (let i = 0; i < message.rules.length; i++)
            UserAttributePushRule.internalBinaryWrite(message.rules[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateRequest
 */
export const UserAttributePushRuleServiceUpdateRequest = new UserAttributePushRuleServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRuleServiceUpdateResponse$Type extends MessageType<UserAttributePushRuleServiceUpdateResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateResponse", [
            { no: 1, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRule }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushRuleServiceUpdateResponse>): UserAttributePushRuleServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rules = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushRuleServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushRuleServiceUpdateResponse): UserAttributePushRuleServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.push_rules.v1.UserAttributePushRule rules */ 1:
                    message.rules.push(UserAttributePushRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushRuleServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.push_rules.v1.UserAttributePushRule rules = 1; */
        for (let i = 0; i < message.rules.length; i++)
            UserAttributePushRule.internalBinaryWrite(message.rules[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateResponse
 */
export const UserAttributePushRuleServiceUpdateResponse = new UserAttributePushRuleServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRuleServiceListRequest$Type extends MessageType<UserAttributePushRuleServiceListRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRuleServiceListRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushRuleServiceListRequest>): UserAttributePushRuleServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushRuleServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushRuleServiceListRequest): UserAttributePushRuleServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushRuleServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceListRequest
 */
export const UserAttributePushRuleServiceListRequest = new UserAttributePushRuleServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRuleServiceListResponse$Type extends MessageType<UserAttributePushRuleServiceListResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRuleServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRule },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushRuleServiceListResponse>): UserAttributePushRuleServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushRuleServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushRuleServiceListResponse): UserAttributePushRuleServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.push_rules.v1.UserAttributePushRule list */ 1:
                    message.list.push(UserAttributePushRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushRuleServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.push_rules.v1.UserAttributePushRule list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserAttributePushRule.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceListResponse
 */
export const UserAttributePushRuleServiceListResponse = new UserAttributePushRuleServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceCreateRequest$Type extends MessageType<UserAttributePushConfigurationServiceCreateRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "user_targeting", kind: "message", T: () => UserTargeting },
            { no: 5, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRuleInput }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationServiceCreateRequest>): UserAttributePushConfigurationServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.enabled = false;
        message.rules = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationServiceCreateRequest): UserAttributePushConfigurationServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* bool enabled */ 3:
                    message.enabled = reader.bool();
                    break;
                case /* c1.api.push_rules.v1.UserTargeting user_targeting */ 4:
                    message.userTargeting = UserTargeting.internalBinaryRead(reader, reader.uint32(), options, message.userTargeting);
                    break;
                case /* repeated c1.api.push_rules.v1.UserAttributePushRuleInput rules */ 5:
                    message.rules.push(UserAttributePushRuleInput.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* bool enabled = 3; */
        if (message.enabled !== false)
            writer.tag(3, WireType.Varint).bool(message.enabled);
        /* c1.api.push_rules.v1.UserTargeting user_targeting = 4; */
        if (message.userTargeting)
            UserTargeting.internalBinaryWrite(message.userTargeting, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.push_rules.v1.UserAttributePushRuleInput rules = 5; */
        for (let i = 0; i < message.rules.length; i++)
            UserAttributePushRuleInput.internalBinaryWrite(message.rules[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateRequest
 */
export const UserAttributePushConfigurationServiceCreateRequest = new UserAttributePushConfigurationServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceCreateResponse$Type extends MessageType<UserAttributePushConfigurationServiceCreateResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateResponse", [
            { no: 1, name: "configuration", kind: "message", T: () => UserAttributePushConfiguration },
            { no: 2, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRule }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationServiceCreateResponse>): UserAttributePushConfigurationServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rules = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationServiceCreateResponse): UserAttributePushConfigurationServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.push_rules.v1.UserAttributePushConfiguration configuration */ 1:
                    message.configuration = UserAttributePushConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.configuration);
                    break;
                case /* repeated c1.api.push_rules.v1.UserAttributePushRule rules */ 2:
                    message.rules.push(UserAttributePushRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.push_rules.v1.UserAttributePushConfiguration configuration = 1; */
        if (message.configuration)
            UserAttributePushConfiguration.internalBinaryWrite(message.configuration, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.push_rules.v1.UserAttributePushRule rules = 2; */
        for (let i = 0; i < message.rules.length; i++)
            UserAttributePushRule.internalBinaryWrite(message.rules[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateResponse
 */
export const UserAttributePushConfigurationServiceCreateResponse = new UserAttributePushConfigurationServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRuleInput$Type extends MessageType<UserAttributePushRuleInput> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRuleInput", [
            { no: 1, name: "target_attribute_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "255" } } } },
            { no: 100, name: "none", kind: "message", oneof: "mappingRule", T: () => None },
            { no: 101, name: "c1_attribute", kind: "message", oneof: "mappingRule", T: () => C1Attribute },
            { no: 102, name: "cel_expression", kind: "message", oneof: "mappingRule", T: () => CelExpression }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushRuleInput>): UserAttributePushRuleInput {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetAttributeName = "";
        message.mappingRule = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushRuleInput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushRuleInput): UserAttributePushRuleInput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_attribute_name */ 1:
                    message.targetAttributeName = reader.string();
                    break;
                case /* c1.api.push_rules.v1.None none */ 100:
                    message.mappingRule = {
                        oneofKind: "none",
                        none: None.internalBinaryRead(reader, reader.uint32(), options, (message.mappingRule as any).none)
                    };
                    break;
                case /* c1.api.push_rules.v1.C1Attribute c1_attribute */ 101:
                    message.mappingRule = {
                        oneofKind: "c1Attribute",
                        c1Attribute: C1Attribute.internalBinaryRead(reader, reader.uint32(), options, (message.mappingRule as any).c1Attribute)
                    };
                    break;
                case /* c1.api.push_rules.v1.CelExpression cel_expression */ 102:
                    message.mappingRule = {
                        oneofKind: "celExpression",
                        celExpression: CelExpression.internalBinaryRead(reader, reader.uint32(), options, (message.mappingRule as any).celExpression)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushRuleInput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_attribute_name = 1; */
        if (message.targetAttributeName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetAttributeName);
        /* c1.api.push_rules.v1.None none = 100; */
        if (message.mappingRule.oneofKind === "none")
            None.internalBinaryWrite(message.mappingRule.none, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.push_rules.v1.C1Attribute c1_attribute = 101; */
        if (message.mappingRule.oneofKind === "c1Attribute")
            C1Attribute.internalBinaryWrite(message.mappingRule.c1Attribute, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.push_rules.v1.CelExpression cel_expression = 102; */
        if (message.mappingRule.oneofKind === "celExpression")
            CelExpression.internalBinaryWrite(message.mappingRule.celExpression, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRuleInput
 */
export const UserAttributePushRuleInput = new UserAttributePushRuleInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushableAttribute$Type extends MessageType<PushableAttribute> {
    constructor() {
        super("c1.api.push_rules.v1.PushableAttribute", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PushableAttribute>): PushableAttribute {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.displayName = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<PushableAttribute>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PushableAttribute): PushableAttribute {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PushableAttribute, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.PushableAttribute
 */
export const PushableAttribute = new PushableAttribute$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorPushSchemaRequest$Type extends MessageType<GetConnectorPushSchemaRequest> {
    constructor() {
        super("c1.api.push_rules.v1.GetConnectorPushSchemaRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetConnectorPushSchemaRequest>): GetConnectorPushSchemaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<GetConnectorPushSchemaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorPushSchemaRequest): GetConnectorPushSchemaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorPushSchemaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.GetConnectorPushSchemaRequest
 */
export const GetConnectorPushSchemaRequest = new GetConnectorPushSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorPushSchemaResponse$Type extends MessageType<GetConnectorPushSchemaResponse> {
    constructor() {
        super("c1.api.push_rules.v1.GetConnectorPushSchemaResponse", [
            { no: 1, name: "attributes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PushableAttribute },
            { no: 2, name: "allows_custom_attributes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetConnectorPushSchemaResponse>): GetConnectorPushSchemaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.attributes = [];
        message.allowsCustomAttributes = false;
        if (value !== undefined)
            reflectionMergePartial<GetConnectorPushSchemaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorPushSchemaResponse): GetConnectorPushSchemaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.push_rules.v1.PushableAttribute attributes */ 1:
                    message.attributes.push(PushableAttribute.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool allows_custom_attributes */ 2:
                    message.allowsCustomAttributes = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorPushSchemaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.push_rules.v1.PushableAttribute attributes = 1; */
        for (let i = 0; i < message.attributes.length; i++)
            PushableAttribute.internalBinaryWrite(message.attributes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool allows_custom_attributes = 2; */
        if (message.allowsCustomAttributes !== false)
            writer.tag(2, WireType.Varint).bool(message.allowsCustomAttributes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.GetConnectorPushSchemaResponse
 */
export const GetConnectorPushSchemaResponse = new GetConnectorPushSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceDeleteRequest$Type extends MessageType<UserAttributePushConfigurationServiceDeleteRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationServiceDeleteRequest>): UserAttributePushConfigurationServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationServiceDeleteRequest): UserAttributePushConfigurationServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteRequest
 */
export const UserAttributePushConfigurationServiceDeleteRequest = new UserAttributePushConfigurationServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceDeleteResponse$Type extends MessageType<UserAttributePushConfigurationServiceDeleteResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<UserAttributePushConfigurationServiceDeleteResponse>): UserAttributePushConfigurationServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UserAttributePushConfigurationServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributePushConfigurationServiceDeleteResponse): UserAttributePushConfigurationServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributePushConfigurationServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteResponse
 */
export const UserAttributePushConfigurationServiceDeleteResponse = new UserAttributePushConfigurationServiceDeleteResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.push_rules.v1.UserAttributePushConfigurationService
 */
export const UserAttributePushConfigurationService = new ServiceType("c1.api.push_rules.v1.UserAttributePushConfigurationService", [
    { name: "CreateUserAttributePushConfiguration", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushConfigurationServiceCreateRequest, O: UserAttributePushConfigurationServiceCreateResponse },
    { name: "GetUserAttributePushConfiguration", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushConfigurationServiceGetRequest, O: UserAttributePushConfigurationServiceGetResponse },
    { name: "UpdateUserAttributePushConfiguration", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushConfigurationServiceUpdateRequest, O: UserAttributePushConfigurationServiceUpdateResponse },
    { name: "ListUserAttributePushConfigurations", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushConfigurationServiceListRequest, O: UserAttributePushConfigurationServiceListResponse },
    { name: "DeleteUserAttributePushConfiguration", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushConfigurationServiceDeleteRequest, O: UserAttributePushConfigurationServiceDeleteResponse },
    { name: "GetConnectorPushSchema", options: { "authz.method": { role: "OWNER" } }, I: GetConnectorPushSchemaRequest, O: GetConnectorPushSchemaResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.push_rules.v1.UserAttributePushRuleService
 */
export const UserAttributePushRuleService = new ServiceType("c1.api.push_rules.v1.UserAttributePushRuleService", [
    { name: "ListUserAttributePushRules", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushRuleServiceListRequest, O: UserAttributePushRuleServiceListResponse },
    { name: "UpdateUserAttributePushRules", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushRuleServiceUpdateRequest, O: UserAttributePushRuleServiceUpdateResponse }
]);
